import { type ActionsObject, makeAction, makeReducer } from '@finn-no/redux-actions';
import type { AppState } from '../interfaces';

export const actions: ActionsObject<AppState> = {};

actions.openFilter = makeAction('OPEN_FILTERS', (state, action) => ({ ...state, filtersOpen: action.payload }));

export const appStateReducer = makeReducer<AppState>(actions);
